import { accountRepo } from "@/repositories/accountRepo";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";

export const useGetAccountByEmail = (email: string) => {
  return useObservable(() => accountRepo.getByEmail(email), [email]);
};

export const useGetMyAccount = () => {
  return useObservable(() => accountRepo.getMyAccount(), []);
};
